export {default as voronoi} from "./voronoi";



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/src/index.js
// module id = ./node_modules/d3-voronoi/src/index.js
// module chunks = 1